import React from "react";
import PillCapturando from "../../../components/pillEstatus/PillCapturando";

export default function Capturando() {
  return <PillCapturando />;
}
